enum Language {
  GERMAN = 'de',
  ENGLISH = 'en',
}

export default Language
